//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";
import { mapGetters, mapActions } from "vuex";
import { copyToClipboard } from "@/assets/js/appFunc";
import exposeApiDefineRequest from "@/components/Diagrams/config/subcomponents/expose-api-define-request.vue";
import exposeApiActionRules from "@/components/Diagrams/config/subcomponents/expose-api-action-rules.vue";
import exposeApiRuleEditor from "@/components/Diagrams/config/subcomponents/expose-api-rule-editor.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSelectionCard from "@/components/Generics/AQSelectionCard/AQSelectionCard.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQCard from "@/components/Generics/AQCard/AQCard.vue";
import AQChip from "@/components/Generics/AQChip/AQChip.vue";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";

export default {
    components: {
        exposeApiDefineRequest,
        exposeApiActionRules,
        exposeApiRuleEditor,
        draggable,
        AQInput,
        AQTooltip,
        AQButton,
        AQSelectionCard,
        AQModal,
        AQChip,
        AQDialog,
        AQCard
    },

    props: {
        uuid: {
            required: true,
            type: String
        },
        readonly: {
            type: Boolean
        },
        value: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            defaultPathName: "",
            initialDefaultPath: "",
            initialActionRules: [],
            configApiTitle: "",
            initialClients: null,
            showTooltip: false,
            modalOpened: false,
            currentStep: "1",
            requestDef: false,
            defineReq: null,
            requests: [],
            sentDefaultpath: null,
            defaultPath: null,
            data: [],
            dataToLoad: [],
            objectRequest: [],
            defaultPathParam: "",
            actRuleProp: [],
            finished: false,
            validationLabel: this.$t("diagrams.components.exposeApi.skipBtn"),
            editRulesModal: false,
            ruleId: null,
            rulesParentArray: [],
            drag: false,
            search: "",
            isDisable: true,
            actionRules: [],
            isClosed: false,
            exposedClientsModal: false,
            availableClients: false,
            localClients: null,
            showExposedClientsSave: false,
            initialData: {},
            showDialog: false,
            exposeClientsDlg: false
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData", "exposeStartUrl", "diagramData", "selectedPluginUuid"]),
        ...mapGetters("apis", ["allExposedApis"]),
        getSelectedFields() {
            const dataExposeApi = this.selectedPluginConfigData
                                    && this.selectedPluginConfigData.apiConfigure
                                    && this.selectedPluginConfigData.apiConfigure.dataExposeApi
                ? this.selectedPluginConfigData.apiConfigure.dataExposeApi : null;
            let selectedFields = [];
            if (this.dataToLoad && this.dataToLoad.length) {
                selectedFields = this.dataToLoad[0].requestDataModel;
            } else if (dataExposeApi && dataExposeApi.length) {
                selectedFields = dataExposeApi[0].requestDataModel;
            }
            return selectedFields;
        },
        hasDone() {
            return {
                label: this.$t("generic.done"),
                disabled: !this.showExposedClientsSave
            };
        },
        configDone() {
            return {
                label: this.$t("generic.done"),
                disabled: this.isDisable
            };
        },
        skipContinueButton() {
            if (this.rulesParentArray && this.rulesParentArray.length) {
                return this.$t("diagrams.components.exposeApi.continueLabel");
            }
            return this.$t("diagrams.components.exposeApi.skipLabel");
        },
        isSkip() {
            return !(this.rulesParentArray && this.rulesParentArray.length);
        },
        setConfigApiTitle() {
            return this.configApiTitle;
        },
        setTitle() {
            let exposeTitle = "";
            if (this.computedExposedClients && this.computedExposedClients.length) {
                exposeTitle = this.computedExposedClients.length > 1
                    ? `${this.computedExposedClients.length} ${this.$t("diagrams.components.configApi.clientsDefined")}`
                    : `${this.computedExposedClients[0].name} ${this.$t("diagrams.components.configApi.client")}`;
            }
            return exposeTitle;
        },
        localComputedClients: {
            get() {
                return this.localClients || (this.value ? this.value.startClients : []);
            },
            set(v) {
                this.localClients = v || [];
            }
        },
        filterAllExposedApis() {
            let apis = [];
            if (this.search) {
                const lowerCaseValue = this.search.toLowerCase();
                apis = this.allExposedApis.filter(item => (item.name ? item.name.toLowerCase().includes(lowerCaseValue) : false));
            } else {
                apis = this.allExposedApis;
            }
            return apis;
        },
        computedExposedClients() {
            let result = [];
            if (this.value && this.value.startClients && this.value.startClients.length) {
                result = this.filterClients(this.value.startClients);
            } else if (this.initialClients) {
                result = this.filterClients(this.initialClients);
            }
            return result;
        }
    },
    watch: {
        defaultPathName: {
            handler(val) {
                this.configApiTitle = val;
            }
        },
        initialActionRules: {
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.configApiTitle = `${newVal.length} ${this.$t("diagrams.components.configApi.rulesDefined")}`;
                } else {
                    this.configApiTitle = this.defaultPathName;
                }
            }
        },
        allExposedApis: {
            handler(newValue) {
                this.availableClients = !!(newValue && newValue.length > 0);
            },
            immediate: true
        }
    },
    created() {
        const { defaultPath, requests } = this.selectedPluginConfigData.apiConfigure || {};
        if (defaultPath && requests) {
            this.currentStep = "4";
        }
        this.availableClients = !!(this.allExposedApis && this.allExposedApis.length > 0);
    },

    mounted() {
        this.showExposedClientsSave = false;
        this.getUrlExpose(this.selectedPluginConfigData.uuid);
        this.getAllExposedApisData();
        this.setDefaultPathAndTitle();
    },

    activated() {
        this.getUrlExpose(this.selectedPluginConfigData.uuid);
        this.setDefaultPathAndTitle();
    },

    methods: {
        copyToClipboard,
        ...mapActions("apis", ["getAllExposedApis"]),
        ...mapActions("diagrams", ["getUrlExpose"]),

        afterHide() {
            this.$emit("input", false);
        },
        setDefaultPathAndTitle() {
            if (this.selectedPluginConfigData.apiConfigure) {
                this.initialDefaultPath = this.selectedPluginConfigData.apiConfigure.defaultPath;
                this.initialClients = this.selectedPluginConfigData.apiConfigure.exposedClients || [];
                this.initialActionRules = this.selectedPluginConfigData.apiConfigure.actionRules;
                if (this.selectedPluginConfigData.apiConfigure.defaultPath) {
                    const { connectors } = this.diagramData;

                    for (let i = 0; i < connectors.length; i++) {
                        if (connectors[i].from === this.selectedPluginUuid) {
                            for (let j = 0; j < this.diagramData.content.length; j++) {
                                if (connectors[i].to === this.diagramData.content[j].uuid && connectors[i].label.labelOf === this.initialDefaultPath) {
                                    this.defaultPathName = this.diagramData.content[j].label.value;
                                }
                            }
                        }
                    }
                    if (this.initialActionRules.length) {
                        this.configApiTitle = `${this.initialActionRules.length + 1} ${this.$t("diagrams.components.configApi.rulesDefined")}`;
                    } else {
                        this.configApiTitle = this.defaultPathName;
                    }
                }
            }
        },
        filterClients(clientsArray) {
            const clients = [];
            clientsArray.forEach(el => {
                const client = this.allExposedApis.filter(item => item.id === el);
                if (client && client.length) {
                    clients.push(client[0]);
                }
            });
            return clients;
        },
        cloneValue(value) {
            return value ? JSON.parse(JSON.stringify(value)) : value;
        },
        step() {
            if (!this.isClosed) {
                this.objectRequest = this.dataToLoad && this.dataToLoad.length > 0 ? this.cloneValue(this.dataToLoad[0].requestDataModel) : [];
                this.defaultPathParam = this.defaultPath;
                this.actRuleProp = this.actionRules;
            } else {
                const { dataExposeApi, defaultPath, actionRules } = this.selectedPluginConfigData.apiConfigure || {};
                this.objectRequest = dataExposeApi && dataExposeApi[0] ? this.cloneValue(dataExposeApi[0].requestDataModel) : [];
                this.defaultPathParam = defaultPath || "";
                this.actRuleProp = actionRules ? this.cloneValue(actionRules) : [];
            }
        },
        openModal() {
            if (!this.readonly) {
                const { defaultPath, requests, dataExposeApi, validationRules, actionRules } = this.selectedPluginConfigData.apiConfigure || {};
                this.modalOpened = true;
                if (defaultPath && requests) {
                    this.currentStep = "4";
                }
                this.defaultPathParam = defaultPath || "";
                this.objectRequest = dataExposeApi ? this.cloneValue(dataExposeApi.requestDataModel) : [];
                this.rulesParentArray = validationRules ? this.cloneValue(validationRules) : [];
                this.actRuleProp = actionRules ? this.cloneValue(actionRules) : [];
                this.actionRules = actionRules ? this.cloneValue(actionRules) : [];
                this.isClosed = false;
                this.initialData = this.getAllData();
            }
        },
        getAllData() {
            const { defaultPath, requests, dataExposeApi, validationRules, actionRules, exposedClients } = this.selectedPluginConfigData.apiConfigure || {};
            const setValue = v => (v ? this.cloneValue(v) : []);
            return {
                requests: this.requests && (this.requests.length || Object.entries(this.requests).length) ? this.cloneValue(this.requests) : setValue(requests),
                defaultPath: this.defaultPath || defaultPath || "",
                validationRules: this.rulesParentArray
                                && this.rulesParentArray.length ? this.cloneValue(this.reindexElemnt("validation")) : setValue(validationRules),
                dataExposeApi: this.dataToLoad && this.dataToLoad.length ? this.cloneValue(this.dataToLoad) : setValue(dataExposeApi),
                exposedClients: this.localComputedClients
                                && this.localComputedClients.length ? this.cloneValue(this.localComputedClients) : setValue(exposedClients),
                actionRules: this.actionRules && this.actionRules.length ? this.cloneValue(this.reindexElemnt("action")) : setValue(actionRules)
            };
        },
        openExposedClientsModal() {
            if (!this.readonly) {
                const { exposedClients } = this.selectedPluginConfigData.apiConfigure || {};
                this.exposedClientsModal = true;
                this.getAllExposedApisData();
                this.showExposedClientsSave = false;
                this.localComputedClients = exposedClients || [];
                this.localClients = exposedClients || [];
            }
        },
        changeClients() {
            this.showExposedClientsSave = !!this.localClients.length;
        },

        getAllExposedApisData() {
            if (!this.latestVersionId) {
                this.$store.dispatch("version/getLatestVersionId").then(
                    data => {
                        if (data) {
                            this.getAllExposedApis();
                        }
                    }
                );
            } else {
                this.getAllExposedApis();
            }
        },

        ruleModalClosed() {
            this.editRulesModal = false;
        },
        addRulesModal() {
            this.editRulesModal = true;
        },
        addRule() {
            this.editRulesModal = true;
            this.ruleId = null;
        },
        editRule(ruleId) {
            this.editRulesModal = true;
            this.ruleId = ruleId;
        },
        rulesFinalArray(value) {
            let found = false;
            for (let i = 0; i < this.rulesParentArray.length; i++) {
                if (this.rulesParentArray[i].uuid === value.uuid) {
                    this.rulesParentArray[i] = value;
                    this.rulesParentArray[i].index = i;
                    found = true;
                }
            }
            if (!found) {
                const obj = {
                    uuid: value.uuid,
                    name: value.name,
                    description: value.description,
                    conditions: value.conditions,
                    index: this.rulesParentArray.length ? this.rulesParentArray.length : 0,
                    error: {
                        code: value.error.code,
                        message: value.error.message
                    }
                };
                this.rulesParentArray.push(obj);
            }
        },
        sendValue(value) {
            this.defaultPath = value && value.uuid ? value.uuid : value;
            if (value && typeof value === "object") {
                this.defaultPathName = value.name;
            }
        },

        changeActionsRules(value) {
            this.actionRules = value || [];
        },
        showButton(value) {
            this.requestDef = value;
        },
        finishStepper() {
            this.$refs.exposeStepper.next();
            this.isDisable = false;
        },
        sendRequestValue(value) {
            this.dataToLoad = [];
            if (value && value.length > 0) {
                const [firstItem, secondItem, thirdItem] = value;
                this.requests = firstItem;
                this.requestDef = thirdItem.requestVariable;
                this.dataToLoad.push({ requestDataModel: secondItem });
            }
        },
        reindexElemnt(value) {
            let rules = [];
            if (value === "action") {
                for (let i = 0; i < this.actionRules.length; i++) {
                    this.actionRules[i].index = i;
                }
                rules = this.actionRules;
            } else if (value === "validation") {
                for (let i = 0; i < this.rulesParentArray.length; i++) {
                    this.rulesParentArray[i].index = i;
                }
                rules = this.rulesParentArray;
            }
            return rules;
        },

        goToApi() {
            this.$router.push({ name: "expose", query: { fromExposed: true } });
            this.exposedClientsModal = false;
        },
        dialogConfirmAction(action) {
            if (action === "ok") {
                this.resetData();
            }
            this.showDialog = false;
        },
        resetData() {
            this.modalOpened = false;
            this.isClosed = true;
            const { defaultPath, dataExposeApi, validationRules, actionRules } = this.selectedPluginConfigData.apiConfigure || {};

            this.defaultPath = defaultPath || "";
            this.dataToLoad = dataExposeApi || [];
            this.rulesParentArray = validationRules || [];
            this.actRuleProp = actionRules || [];
            if (this.$refs.exposeStepper) {
                this.$refs.exposeStepper.goTo("1");
            }
            if (this.defaultPath) {
                this.checkSelectedData();
            } else {
                this.defaultPathName = "";
            }
            this.isDisable = true;
            const apiConfig = this.selectedPluginConfigData.apiConfigure;
            const { first } = apiConfig && apiConfig.dataExposeApi ? apiConfig.dataExposeApi : [];
            this.requestDef = !!(first && first.requestDataModel);
        },
        checkSelectedData() {
            const { connectors } = this.diagramData;
            if (connectors) {
                for (let i = 0; i < connectors.length; i++) {
                    if (connectors[i].from === this.selectedPluginUuid) {
                        for (let j = 0; j < this.diagramData.content.length; j++) {
                            if (connectors[i].to === this.diagramData.content[j].uuid && connectors[i].label.labelOf === this.initialDefaultPath) {
                                this.defaultPathName = this.diagramData.content[j].label.value;
                            }
                        }
                    }
                }
                if (this.initialActionRules.length) {
                    this.configApiTitle = `${this.initialActionRules.length} ${this.$t("diagrams.components.configApi.rulesDefined")}`;
                } else {
                    this.configApiTitle = this.defaultPathName;
                }
            }
        },
        getPayload() {
            const { apiConfigure } = this.selectedPluginConfigData;
            const attributes = ["exposedClients", "dataExposeApi", "requests"];
            const getAttributes = value => ((this.exposedClientsModal || attributes.includes(value)) && apiConfigure ? apiConfigure[value] : []);
            return {
                requests: this.requests && (this.requests.length || Object.entries(this.requests).length) ? this.requests : getAttributes("requests"),
                defaultPath: this.defaultPath || (apiConfigure ? apiConfigure.defaultPath : ""),
                validationRules: this.rulesParentArray && this.rulesParentArray.length ? this.reindexElemnt("validation") : getAttributes("validationRules"),
                dataExposeApi: this.dataToLoad && this.dataToLoad.length ? this.dataToLoad : getAttributes("dataExposeApi"),
                exposedClients: this.localComputedClients && this.localComputedClients.length ? this.localComputedClients : getAttributes("exposedClients"),
                actionRules: this.actionRules && this.actionRules.length ? this.reindexElemnt("action") : getAttributes("actionRules")
            };
        },

        setExposeAction($event) {
            if ($event === "primary") {
                const payload = this.getPayload();
                this.initialActionRules = payload.actionRules;
                this.$store.commit("diagrams/setConfigData", {
                    uuid: this.uuid,
                    value: payload,
                    property: "apiConfigure"
                });
                if (this.modalOpened) {
                    this.isClosed = false;
                    this.modalOpened = false;
                }

                if (this.exposedClientsModal) {
                    this.$emit("input", {
                        startClients: this.localClients
                    });
                    this.exposedClientsModal = false;
                }
                if (this.$refs.exposeStepper) {
                    this.$refs.exposeStepper.goTo("1");
                }
                this.isDisable = true;
            } else if ($event === "close") {
                if (this.modalOpened) {
                    const stringifyVal = value => JSON.stringify(value);
                    const currentData = this.getPayload();
                    const diff = stringifyVal(this.initialData) !== stringifyVal(currentData);
                    if (diff) {
                        this.showDialog = true;
                    } else {
                        this.resetData();
                    }
                }
                if (this.exposedClientsModal) {
                    const { apiConfigure } = this.selectedPluginConfigData || {};
                    if (this.showExposedClientsSave
                    || (apiConfigure && apiConfigure.exposedClients
                    && JSON.stringify(apiConfigure.exposedClients) !== JSON.stringify(this.localComputedClients))) {
                        this.exposeClientsDlg = true;
                    } else {
                        this.exposedClientsModal = false;
                        this.showExposedClientsSave = false;
                    }
                }
            }
        },
        exposeClientsOk() {
            this.exposedClientsModal = false;
            this.showExposedClientsSave = false;
        }
    }
};
